<template>
    <div :class="layout != 4 ? 'style-box-wrapper dosiin_mt-2' : 'topic-wrapper' ">
        <div class="title_style">
            <h4>Chủ đề bài viết</h4>
            <router-link :to="{ name : 'topic'}" class="title_style-more">
                <span>Xem thêm </span><i class="dsi dsi-act-arrow-forward"></i>
            </router-link>
        </div>
        
        <Skeleton  v-if="loading"/>
        <div v-else class="topic_inner">
            <div class="topic_item" v-for="(group , i ) in groupTag" :key="i">
                <router-link :to="{ name : 'style-cat' , query : { catId : group.id }}" class="topic_overlay"> 
                    <img 
                        v-lazy="_catetagThumbnail(group.main_pair)" 
                        class="cm-image"
                    >
                    <div class="topic_item-desc">
                        <div class="topic_item-icon">
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7084 15.1231V12.2811L17.7056 12.2697C17.6723 12.1364 17.5413 12.0011 17.3677 12.0011H14.6367L15.2834 8.99885H17.3677C17.463 8.99885 17.5498 8.96666 17.613 8.90344C17.6762 8.84021 17.7084 8.7534 17.7084 8.65809V5.88297C17.7084 5.78767 17.6762 5.70086 17.613 5.63763C17.5498 5.5744 17.463 5.54222 17.3677 5.54222H16.0114L16.502 3.20591C16.5353 3.09886 16.5001 2.9944 16.4347 2.92463C16.3631 2.82326 16.2576 2.79166 16.1643 2.79166H13.4137C13.2492 2.79166 13.1092 2.89386 13.0749 3.06414L13.0748 3.06463L12.5506 5.56678H9.55246L10.0431 3.23047C10.0744 3.12963 10.0451 3.03109 9.98686 2.96167C9.96683 2.90289 9.9311 2.85847 9.88327 2.82978C9.83209 2.79907 9.77588 2.79166 9.72994 2.79166H6.95481C6.79024 2.79166 6.65027 2.89388 6.616 3.06419L6.61591 3.06463L6.09165 5.56678H2.6325C2.5372 5.56678 2.45038 5.59896 2.38716 5.66219C2.32393 5.72542 2.29175 5.81223 2.29175 5.90753V8.65809C2.29175 8.7534 2.32393 8.84021 2.38716 8.90344C2.45038 8.96666 2.5372 8.99885 2.6325 8.99885H5.36345L4.71681 12.0011H2.6325C2.5372 12.0011 2.45038 12.0333 2.38716 12.0965C2.32393 12.1598 2.29175 12.2466 2.29175 12.3419V15.0924C2.29175 15.1878 2.32393 15.2746 2.38716 15.3378C2.45038 15.401 2.5372 15.4332 2.6325 15.4332H3.98879L3.49816 17.7695C3.46563 17.8742 3.49851 17.9764 3.56119 18.0461C3.5925 18.1035 3.63357 18.1453 3.68286 18.1721C3.73484 18.2005 3.78876 18.2083 3.83587 18.2083H6.58643C6.751 18.2083 6.89098 18.1061 6.92525 17.9358L6.92534 17.9354L7.4496 15.4332H10.4477L9.95708 17.7695C9.9227 17.8801 9.96135 17.988 10.031 18.0577C10.0863 18.113 10.1831 18.1838 10.2948 18.1838H13.0453C13.2099 18.1838 13.3499 18.0816 13.3842 17.9113L13.3843 17.9108L13.9085 15.4086H17.4229C17.5806 15.4086 17.7084 15.2808 17.7084 15.1231ZM13.1629 5.95209L13.6873 3.47316H15.7519L14.6725 8.5102L14.6479 8.58401L13.926 12.0011H11.8616L13.1629 5.95209ZM5.32869 12.485L6.074 8.99885H8.13873L6.31302 17.5268H4.2478L4.73928 15.1864L4.73944 15.1857L5.32869 12.485ZM17.0515 14.8714L17.0279 12.7072H8.06297L7.61318 14.7763H13.6348V14.8714H17.0515ZM17.0269 6.22372V8.29278H15.4228L15.8726 6.22372H17.0269ZM11.8224 8.99885L11.1757 12.0011H8.1778L8.82444 8.99885H11.8224ZM6.77819 5.54222L7.22798 3.47316H9.2926L8.8428 5.54222H6.77819ZM2.97325 8.31734V6.24828H12.387L11.9372 8.31734H2.97325ZM2.97325 14.7763V12.7072H4.57735L4.12755 14.7763H2.97325ZM13.222 15.4578L12.7722 17.5268H10.7076L11.1574 15.4578H13.222Z" fill="#E6E6E6"></path>
                            </svg>
                        </div>
                        <div class="topic_item-txt">
                            <h5 v-text="group.category_name"></h5>
                            <p>{{group.count}} <span>bài viết</span></p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

    import TagService from '@/services/tag';
    import Skeleton from '@/components/skeletons/CatTag';
    import { ref } from 'vue';
    export default {
        components:{
            Skeleton
        },
        setup(){
            const groupTag = ref([]);
            const loading  = ref(true);
            getGroupTags();

            async function getGroupTags(){
                const response = await TagService.fetchGroupTags('&limit=6');                
                groupTag.value.push(...response.data.group_tags);
                loading.value = false;
            }

            return {
                groupTag,
                loading
            }
        }
    }
</script>

<style scoped>
    .topic-wrapper {
        padding: 16px 18px !important;
    }

    .topic-wrapper .topic_item img {
        height: -webkit-fill-available;
        object-fit: inherit;
    }
</style>